import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const AccessibilityFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function AccessibilityFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M12 6.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
          <path d="m15.85 17.66 1.71 5.84h-3.13l-1.45-4.95s-.01-.03-.01-.04l-.67-2.3c-.08-.26-.52-.26-.6 0l-.67 2.3s-.01.03-.01.04l-.24.83-1.21 4.12H6.43l1.38-4.68.35-1.17c.55-1.92.84-3.91.84-5.91v-1.35c-2.47-.17-4.7-.55-6.46-1.12l.92-2.86C5.6 7.1 8.71 7.5 12 7.5c3.29 0 6.4-.4 8.54-1.09l.92 2.86c-1.76.57-3.99.95-6.46 1.12v1.35c0 2 .29 3.99.85 5.92Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default AccessibilityFilled;